import { render, staticRenderFns } from "./ButtonCheckoutConfirm.vue?vue&type=template&id=143f4bc1&"
import script from "./ButtonCheckoutConfirm.vue?vue&type=script&lang=js&"
export * from "./ButtonCheckoutConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports